'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$0024anon$002497 from "./presto.types$$anon$97.js";
import * as $j_presto$002etypes$0024$002dLimited$002dLocal$002dTime$0024 from "./presto.types$-Limited-Local-Time$.js";
var $p;
/** @constructor */
function $c_Lpresto_types$$anon$96() {
  this.c4k = null;
  this.c4c = null;
  this.c4d = false;
  this.c4l = null;
  this.c4m = false;
  this.c4p = null;
  this.c4i = null;
  this.c4j = false;
  this.c4e = null;
  this.c4f = false;
  this.c4g = null;
  this.c4h = false;
  this.c4n = false;
  this.c4o = false;
  this.c4k = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.c4p = "LimitedLocalTime";
}
export { $c_Lpresto_types$$anon$96 as $c_Lpresto_types$$anon$96 };
$p = $c_Lpresto_types$$anon$96.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$$anon$96;
/** @constructor */
function $h_Lpresto_types$$anon$96() {
}
export { $h_Lpresto_types$$anon$96 as $h_Lpresto_types$$anon$96 };
$h_Lpresto_types$$anon$96.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.K = (function() {
  return this.c4k;
});
$p.M = (function() {
  if ((!this.c4d)) {
    this.c4c = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.c4d = true;
  }
  return this.c4c;
});
$p.O = (function() {
  if ((!this.c4m)) {
    this.c4l = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.c4m = true;
  }
  return this.c4l;
});
$p.D = (function() {
  return this.c4p;
});
$p.t = (function() {
  if ((!this.c4j)) {
    this.c4i = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hour", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("minute", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c4j = true;
  }
  return this.c4i;
});
$p.N = (function() {
  if ((!this.c4f)) {
    this.c4e = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bC, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().bC, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.c4f = true;
  }
  return this.c4e;
});
$p.Q = (function() {
  if ((!this.c4h)) {
    this.c4g = new $j_presto$002etypes$0024$0024anon$002497.$c_Lpresto_types$$anon$97();
    this.c4h = true;
  }
  return this.c4g;
});
$p.v = (function() {
  if ((!this.c4o)) {
    this.c4n = false;
    this.c4o = true;
  }
  return this.c4n;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee127) => ((p) => \u03b4scrutinee127.csi(p)))($j_presto$002etypes$0024$002dLimited$002dLocal$002dTime$0024.$m_Lpresto_types$LimitedLocalTime$())));
});
var $d_Lpresto_types$$anon$96 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$$anon$96, "presto.types$$anon$96", ({
  Ys: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_types$$anon$96 as $d_Lpresto_types$$anon$96 };
//# sourceMappingURL=presto.types$$anon$96.js.map
